import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getNotificationById } from '../../helpers/api_helper';

const useNotificationDetails = (notificationId) => {
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    useEffect(() => {
        const fetchNotification = async () => {
            if (!notificationId || !tenantId) return;

            setLoading(true);
            setError(null);
            try {
                const params = { tenantId, module: 'contabilidad', type: 'email' };
                const response = await getNotificationById(notificationId, params);
                setNotification(response);
            } catch (err) {
                setError(`Failed to fetch notification: ${err.message || 'Unknown error'}`);
                setNotification(null);
            } finally {
                setLoading(false);
            }
        };

        fetchNotification();
    }, [notificationId, tenantId]);

    return { notification, loading, error };
};

export default useNotificationDetails;